import AdminLayout from "../../../components/admin/layout/AdminLayout";
import CreateSurveyor from "../../../components/common/surveyor/CreateSurveyor";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveyorCreatePage() {
  const { userType } = useAuthStore();

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <CreateSurveyor />
    </AdminLayout>
  );
}

export default SurveyorCreatePage;
